import { render, staticRenderFns } from "./projectView.vue?vue&type=template&id=38aeb01e&scoped=true&"
import script from "./projectView.vue?vue&type=script&lang=js&"
export * from "./projectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aeb01e",
  null
  
)

export default component.exports